import { handleError } from '../utils/errorHandler';
import { sanitizeInput } from '../utils/sanitizeInput';
import React, { useState, useEffect } from 'react';
import { API_URL, COLOR_FONT_TITLE, esCelular } from '../Config';
import { apiFetch } from '../apiClient';
import { } from '../Transversal';
import { DEFAULT_FILTER, ArcFiltros } from './SesionApp';
import { relative } from 'path';
import { FaSort, FaDownload, FaEraser } from 'react-icons/fa';
import { useUrlParams } from '../hooks/useUrlParams';
import { getAnioDefault } from '../utils/getAnioDefault';

interface HeaderProps {
  onFilterChange: (filtrar: number) => void;
  codigoDivipola: string;
  visibleFilters: string[]; // New property to indicate visible filters
}

class DivipolaCantidad {
  public codigoDivipola: string = "";
  public nombre: string = "";
  public cantidad: number = 0;
  public cantidadGlobal: number = 0;
}

let divipolaCantidad: DivipolaCantidad[] = [];
let consecutivo = 0;
let currentYear = 0;
const T302_LABEL = "Plan de Acción de la Sentencia T-302 de 2017";
const T302_DEPTO_CODE = "44";

// Variables globales para manejar el estado de filtros desde limpiarFiltros
let globalSetSelectedFiltersStack: React.Dispatch<React.SetStateAction<string[]>> | null = null;
let globalSetDisabledFilters: React.Dispatch<React.SetStateAction<Set<string>>> | null = null;

const Header: React.FC<HeaderProps> = ({ onFilterChange, visibleFilters, codigoDivipola }) => {
  const [filtros, setFiltros] = useState<FiltroLista[]>([]);
  const [selectedFiltersStack, setSelectedFiltersStack] = useState<string[]>([]);
  const [disabledFilters, setDisabledFilters] = useState<Set<string>>(new Set());

  // Capturar parámetros de URL
  const { primeraInfancia } = useUrlParams();

  // Asignar las funciones a las variables globales para que limpiarFiltros pueda acceder a ellas
  globalSetSelectedFiltersStack = setSelectedFiltersStack;
  globalSetDisabledFilters = setDisabledFilters;

  useEffect(() => {
    getFiltros();
  }, [codigoDivipola]);

  const fetchDatos = async () => {
    try {
      const queryString = Object.keys(DEFAULT_FILTER)
        .filter(key => DEFAULT_FILTER[key as keyof ArcFiltros] !== undefined)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(DEFAULT_FILTER[key as keyof ArcFiltros] ?? '')}`)
        .join('&');

      let url = `${API_URL}/ArcIndicador/GetDivipolaCantidades?${queryString}`
      let response2 = await apiFetch(url);
      let data2 = await response2.json();
      divipolaCantidad.length = 0;
      divipolaCantidad.push(...data2);
      divipolaCantidad = divipolaCantidad.filter((divipola) => divipola.codigoDivipola !== 'TOTAL');
      //filtros
      url = `${API_URL}/ArcIndicador/GetFiltros?${queryString}`
      let response = await apiFetch(url);
      let data = await response.json();

      setFiltros(data);
    } catch (error) {
      handleError(error);
    }
  };

  const getFiltros = async () => {
    await fetchDatos();
  };

  const isT302Active = () => DEFAULT_FILTER.sentenciaT302 === "1" || DEFAULT_FILTER.tipoClasificador === T302_LABEL;

  const handleFilterChange = (field: string) => (event: React.ChangeEvent<HTMLSelectElement>) => {
    // Sanear la entrada del usuario para prevenir XSS/content spoofing
    const value = sanitizeInput(event.target.value);

    // Si se selecciona un valor, agregar al stack y desactivar el penúltimo (no el último)
    if (value && value !== "") {
      setSelectedFiltersStack(prev => {
        const newStack = prev.filter(f => f !== field.toLowerCase()); // Remover si ya existe
        const updatedStack = [...newStack, field.toLowerCase()]; // Agregar al final

        // Desactivar todos excepto el último (el que se acaba de seleccionar)
        setDisabledFilters(prevDisabled => {
          const newDisabled = new Set<string>();
          // Agregar todos los filtros del stack excepto el último
          for (let i = 0; i < updatedStack.length - 1; i++) {
            newDisabled.add(updatedStack[i]);
          }
          return newDisabled;
        });

        return updatedStack;
      });
    } else {
      // Si se limpia el valor, remover del stack y reactivar el filtro
      setSelectedFiltersStack(prev => {
        const newStack = prev.filter(f => f !== field.toLowerCase());

        // Reactivar filtros basado en el nuevo stack (desactivar todos excepto el último)
        setDisabledFilters(prevDisabled => {
          const newDisabled = new Set<string>();
          // Agregar todos los filtros del nuevo stack excepto el último
          for (let i = 0; i < newStack.length - 1; i++) {
            newDisabled.add(newStack[i]);
          }
          return newDisabled;
        });

        return newStack;
      });
    }

    if (field.toLowerCase() === 'anio') {
      currentYear = Number(value);
      DEFAULT_FILTER.anio = currentYear.toString();
    }
    if (field.toLowerCase() === 'tipoclasificador') {
      const wasT302 = DEFAULT_FILTER.sentenciaT302 === "1";
      DEFAULT_FILTER.tipoClasificador = value;
      const enableT302 = value === T302_LABEL;
      DEFAULT_FILTER.sentenciaT302 = enableT302 ? "1" : "";
      if (enableT302) {
        DEFAULT_FILTER.codigoDivipolaDpto = T302_DEPTO_CODE;
        DEFAULT_FILTER.codigoDivipolaMpio = "";
      } else if (wasT302 && DEFAULT_FILTER.codigoDivipolaDpto === T302_DEPTO_CODE) {
        DEFAULT_FILTER.codigoDivipolaDpto = "";
        DEFAULT_FILTER.codigoDivipolaMpio = "";
      }
    }
    if (field.toLowerCase() === 'divipolapdetregion') {
      DEFAULT_FILTER.codigoDivipolaPdetRegion = value;
      DEFAULT_FILTER.codigoDivipolaDpto = "";
      DEFAULT_FILTER.codigoDivipolaPdetMunicipio = "";
      DEFAULT_FILTER.codigoDivipolaMpio = "";
    }
    if (field.toLowerCase() === 'divipolapdetmunicipio') {
      DEFAULT_FILTER.codigoDivipolaPdetMunicipio = value;
      DEFAULT_FILTER.codigoDivipolaMpio = value;
    }
    if (field.toLowerCase() === 'divipolapdetdepartamento') {
      DEFAULT_FILTER.codigoDivipolaDpto = value;
      DEFAULT_FILTER.codigoDivipolaMpio = "";
    }
    if (field.toLowerCase() === 'divipoladpto') {
      if (isT302Active()) {
        DEFAULT_FILTER.codigoDivipolaDpto = T302_DEPTO_CODE;
        DEFAULT_FILTER.codigoDivipolaMpio = "";
      } else {
        DEFAULT_FILTER.codigoDivipolaDpto = value;
        DEFAULT_FILTER.codigoDivipolaMpio = "";
      }
    }
    if (field.toLowerCase() === 'divipolampio') {
      DEFAULT_FILTER.codigoDivipolaMpio = value;
    }
    if (field.toLowerCase() === 'sector') {
      DEFAULT_FILTER.sector = value;
    }
    if (field.toLowerCase() === 'entidad') {
      DEFAULT_FILTER.entidad = value;
    }
    getFiltros();
    consecutivo++;
    onFilterChange(consecutivo);
  };

  const createFilter = (field: string, defaultValue: string = "", width: string = "auto", label: string = "", parentValue: string = "", requieredParent: boolean = false, tooltip: string = "") => {
    // Si es tipoclasificador y primerainfancia=1, mostrar solo un label fijo
    if (field.toLowerCase() === 'tipoclasificador' && primeraInfancia) {
      return (
        <div style={{ float: "left", width: width, marginRight: "0px" }} title={tooltip}>
          {label && (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <label style={{ fontSize: '12px', color: COLOR_FONT_TITLE }}>{label}</label>
              {tooltip && <span style={{ fontSize: '10px', color: 'gray', marginLeft: '0px' }}>{tooltip}</span>}
            </div>
          )}
          <div style={{ width: "100%" }}>
            <div style={{
              float: "left",
              minWidth: "50px",
              width: "92%",
              fontSize: '12px',
              color: 'black',
              padding: '0px 4px',
              border: '1px solid #ffffff',
              borderRadius: '4px',
              backgroundColor: '#ffffff',
              fontWeight: 'normal'
            }}>
              Tablero de control de las Políticas de Primera Infancia, Infancia, Adolescencia y Familias
            </div>
          </div>
        </div>
      );
    }

    let filteredValues = filtros
      .filter(filtro => filtro.nombre == field && filtro.padre == parentValue)
      .map(filtro => ({ valor: filtro.valor, texto: filtro.texto }))
      .filter((value, index, self) => self.findIndex(v => v.valor === value.valor) === index)
      .sort((a, b) => a.texto.localeCompare(b.texto));

    if (field.toLowerCase() === 'tipoclasificador' && DEFAULT_FILTER.tiposClasificadores.toUpperCase().includes('PND')) {
      const hasT302 = filteredValues.some(
        option => option.valor === T302_LABEL || option.texto === T302_LABEL
      );

      if (!hasT302) {
        filteredValues.push({ valor: T302_LABEL, texto: T302_LABEL });
      }
    }

    if (field.toLowerCase() === 'anios') {
      console.log('filtros', filtros);
    }
    if (field.toLowerCase() === 'divipolapdetmunicipio') {
      //remove in filteredValues if not int  divipolaCantidad
      console.log('filteredValues(0)', filteredValues);
      filteredValues = filteredValues.filter(value =>
        divipolaCantidad.some(d => d.codigoDivipola === value.valor)
      );
      console.log('filteredValues(1)', filteredValues);
    }

    // Verificar si el filtro está desactivado por haber sido seleccionado
    const isDisabledBySelection = disabledFilters.has(field.toLowerCase());
    const isDisabledByT302 = isT302Active() && field.toLowerCase() === 'divipoladpto';
    const isDisabled = requieredParent && !parentValue || isDisabledBySelection || isDisabledByT302;

    // Verificar si este filtro es el último en el stack (solo el último puede ser limpiado individualmente)
    const isLastInStack = selectedFiltersStack.length > 0 &&
      selectedFiltersStack[selectedFiltersStack.length - 1] === field.toLowerCase();
    const canClearIndividually = isLastInStack || selectedFiltersStack.length === 0;

    const clearFilter = () => {
      if (canClearIndividually) {
        handleFilterChange(field)({ target: { value: "" } } as React.ChangeEvent<HTMLSelectElement>);
      }
    };
    if (field.toLowerCase() === 'divipolapdetmunicipio') {
      console.log('filteredValues(2)', filteredValues);
    }


    return (
      <div style={{ float: "left", width: width, marginRight: "0px" }} title={tooltip}>
        {label && (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <label style={{ fontSize: '12px', color: COLOR_FONT_TITLE }}>{label}</label>
            {tooltip && <span style={{ fontSize: '10px', color: 'gray', marginLeft: '0px' }}>{tooltip}</span>}
          </div>
        )}
        <div style={{ width: "100%" }}>
          <select onChange={handleFilterChange(field)} style={{ float: "left", minWidth: "50px", width: "92%", fontSize: '12px', color: 'black' }} disabled={isDisabled} value={defaultValue}>
            {field.toLowerCase() !== 'anio' && <option value="">Todos</option>}
            {filteredValues.map(({ valor, texto }) => (
              <option key={valor} value={valor}>
                {texto}
              </option>
            ))}
          </select>
          {defaultValue && field.toLowerCase() !== 'anio' && (
            <button
              onClick={clearFilter}
              style={{
                float: "left",
                fontSize: '12px',
                border: 'none',
                background: 'none',
                cursor: canClearIndividually ? 'pointer' : 'not-allowed',
                color: canClearIndividually ? "#cccccc" : "#e0e0e0",
                opacity: canClearIndividually ? 1 : 0.5
              }}
              disabled={!canClearIndividually}
              title={!canClearIndividually ? "Solo se puede limpiar el último filtro seleccionado" : "Limpiar filtro"}
            >
              X
            </button>
          )}
        </div>
      </div>
    );
  };

  // Función para limpiar todos los filtros de una vez
  const limpiarTodosFiltros = () => {
    limpiarFiltros();
    setSelectedFiltersStack([]);
    setDisabledFilters(new Set());
    consecutivo++;
    onFilterChange(consecutivo);
    getFiltros();
  };

  // Función para reactivar el último filtro seleccionado (LIFO)
  const reactivarUltimoFiltro = () => {
    if (selectedFiltersStack.length > 0) {
      const lastFilter = selectedFiltersStack[selectedFiltersStack.length - 1];

      // Limpiar el valor del filtro según su tipo
      if (lastFilter === 'anio') {
        DEFAULT_FILTER.anio = getAnioDefault();
      } else if (lastFilter === 'tipoclasificador') {
        DEFAULT_FILTER.tipoClasificador = "";
        DEFAULT_FILTER.sentenciaT302 = "";
      } else if (lastFilter === 'divipolapdetregion') {
        DEFAULT_FILTER.codigoDivipolaPdetRegion = "";
      } else if (lastFilter === 'divipolapdetmunicipio') {
        DEFAULT_FILTER.codigoDivipolaPdetMunicipio = "";
        DEFAULT_FILTER.codigoDivipolaMpio = "";
      } else if (lastFilter === 'divipolapdetdepartamento') {
        DEFAULT_FILTER.codigoDivipolaDpto = "";
      } else if (lastFilter === 'divipoladpto') {
        DEFAULT_FILTER.codigoDivipolaDpto = "";
      } else if (lastFilter === 'divipolampio') {
        DEFAULT_FILTER.codigoDivipolaMpio = "";
      } else if (lastFilter === 'sector') {
        DEFAULT_FILTER.sector = "";
      } else if (lastFilter === 'entidad') {
        DEFAULT_FILTER.entidad = "";
      }

      // Remover del stack y reactivar
      setSelectedFiltersStack(prev => prev.slice(0, -1));
      setDisabledFilters(prev => {
        const newSet = new Set(prev);
        newSet.delete(lastFilter);
        return newSet;
      });

      getFiltros();
      consecutivo++;
      onFilterChange(consecutivo);
    }
  };

  let withColumn = "29%";
  if (DEFAULT_FILTER.esPDET == "1") {
    withColumn = "23%";
  }

  return (
    <header style={{ height: "auto", backgroundColor: "#f8f9fa", display: "flex", flexDirection: "column", alignItems: "left", justifyContent: "space-between", padding: "10px" }}>
      <div style={{ justifyContent: "left" }}>
        {visibleFilters.includes("Anio") && createFilter("Anio", DEFAULT_FILTER.anio, "100px", "Año", "", false, "")}
        {visibleFilters.includes("TipoClasificador") && createFilter("TipoClasificador", DEFAULT_FILTER.tipoClasificador, withColumn, "Instrumento", "", false, "")}
        {DEFAULT_FILTER.esPDET == "1" && visibleFilters.includes("DivipolaPdetRegion") && createFilter("DivipolaPdetRegion", DEFAULT_FILTER.codigoDivipolaPdetRegion, withColumn, "Region Pdet:", "", false, "")}
        {DEFAULT_FILTER.esPDET == "" && visibleFilters.includes("DivipolaDpto") && createFilter("DivipolaDpto", isT302Active() ? T302_DEPTO_CODE : DEFAULT_FILTER.codigoDivipolaDpto, withColumn, "Departamento", "", false, "")}
        {DEFAULT_FILTER.esPDET == "1" && visibleFilters.includes("DivipolaPdetDepartamento") && createFilter("DivipolaPdetDepartamento", DEFAULT_FILTER.codigoDivipolaDpto, withColumn, "Departamento Pdet:", DEFAULT_FILTER.codigoDivipolaPdetRegion, false, "seleccione región")}
        {DEFAULT_FILTER.esPDET == "" && visibleFilters.includes("DivipolaMpio") && createFilter("DivipolaMpio", DEFAULT_FILTER.codigoDivipolaMpio, withColumn, "Municipio", DEFAULT_FILTER.codigoDivipolaDpto, true, "Seleccione departamento")}
        {DEFAULT_FILTER.esPDET == "1" && visibleFilters.includes("DivipolaPdetMunicipio") && createFilter("DivipolaPdetMunicipio", DEFAULT_FILTER.codigoDivipolaPdetMunicipio, withColumn, "Municipio Pdet", DEFAULT_FILTER.codigoDivipolaDpto, false, "Seleccione departamento")}
      </div>
      <div style={{ justifyContent: "left", marginTop: "10px" }}>
        {visibleFilters.includes("Sector") && createFilter("Sector", DEFAULT_FILTER.sector, "40%", "Sector", "", false, "")}
        {visibleFilters.includes("Entidad") && createFilter("Entidad", DEFAULT_FILTER.entidad, "40%", "Entidad", DEFAULT_FILTER.sector, true, "Seleccione sector")}

        {selectedFiltersStack.length > 0 && (
          <button
            onClick={reactivarUltimoFiltro}
            style={{
              display: 'none',
              float: 'right',
              marginTop: 18,
              marginRight: 10,
              fontSize: '14px',
              padding: '5px 10px 5px 10px',
              cursor: 'pointer',
              height: '30px',
              border: '1px solid #007bff',
              borderRadius: '5px',
              backgroundColor: '#007bff',
              transition: '.5ms',
              fontFamily: 'WorkSans, Arial, sans-serif',
              lineHeight: '1.2rem',
              fontWeight: 500,
              letterSpacing: '.8px',
              color: '#fff'
            }}>
            ↶ Reactivar último ({selectedFiltersStack.length})
          </button>
        )}

        <button
          onClick={limpiarTodosFiltros}
          style={{
            float: 'right',
            marginTop: 18,
            fontSize: '14px',
            padding: '5px 10px 5px 10px',
            cursor: 'pointer',
            height: '30px',
            border: '1px solid gray',
            borderRadius: '5px',
            backgroundColor: '#919191',
            transition: '.5ms',
            fontFamily: 'WorkSans, Arial, sans-serif',
            lineHeight: '1.2rem',
            fontWeight: 500,
            letterSpacing: '.8px',
            color: '#fff'
          }}>
          <FaEraser /> Limpiar búsqueda
        </button>

      </div>
    </header>
  );
};

export const limpiarFiltros = () => {
  DEFAULT_FILTER.tipoClasificador = "";
  DEFAULT_FILTER.sentenciaT302 = "";
  DEFAULT_FILTER.codigoDivipolaPdetRegion = "";
  DEFAULT_FILTER.codigoDivipolaPdetMunicipio = "";
  DEFAULT_FILTER.codigoDivipolaDpto = "";
  DEFAULT_FILTER.codigoDivipolaMpio = "";
  DEFAULT_FILTER.sector = "";
  DEFAULT_FILTER.entidad = "";
  DEFAULT_FILTER.esPDET = "";
  DEFAULT_FILTER.anio = getAnioDefault();

  // Reactivar todos los filtros
  if (globalSetSelectedFiltersStack) {
    globalSetSelectedFiltersStack([]);
  }
  if (globalSetDisabledFilters) {
    globalSetDisabledFilters(new Set());
  }

}

class FiltroLista {
  public nombre: string = "";
  public valor: string = "";
  public texto: string = "";
  public padre: string = "";
  public orden: number = 0;
}

export default Header;
